import { Component, EventEmitter, forwardRef, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { EscalasRentabilidadeStore, IEscalaRentabilidade } from 'app/domains/core/settings/grupos-rentabilidade/services/escalas-rentabilidade.store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CustomControlValueAccessor } from '../../utils/custom-control-value-accessor/custom-control-value-accessor';
import { ISelectOption } from '../select/models/select-option.interface';
import { ISelectSettings } from '../select/models/select-settings.interface';

@Component({
  selector: 'sgt-grupo-rentabilidade-select',
  templateUrl: './grupo-rentabilidade-select.component.html',
  styles: [
    `
      span {
        font-size: 14px;
        font-weight: 600;
      }
    `
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => GrupoRentabilidadeSelectComponent),
      multi: true
    }
  ]
})
export class GrupoRentabilidadeSelectComponent
  extends CustomControlValueAccessor<number>
  implements OnInit, OnDestroy {

  @Input() set isDisabled(value: boolean) {
    this._isDisabled = value;
    this.settings = {
      ...this.settings,
      isDisabled: value
    };
  }
  get isDisabled(): boolean {
    return this._isDisabled;
  }
  private _isDisabled = false;

  options: ISelectOption[] = [];
  escalaIdByRecordId: { [id: number]: number } = {};
  settings: ISelectSettings = {
    placeholder: 'Selecione o Grupo',
    isClearSelectionAllowed: true,
    isDisabled: false
  };

  private destroy$ = new Subject<void>();
  private selectedId: number | null = null;
  private isFirstOpen = true;

  @Output() changes = new EventEmitter<number | null>();

  constructor(private escalasStore: EscalasRentabilidadeStore) {
    super();
  }

  ngOnInit(): void {
    this.definirCarregando(true);

    this.escalasStore.getEscalas$()
      .pipe(takeUntil(this.destroy$))
      .subscribe(escalas => {
        this.createOptions(escalas);
        this.applyValue();
        this.definirCarregando(false);
      });
  }

  onFirstOpened(): void {
    if (this.isFirstOpen) {
      this.escalasStore.refresh();
      this.isFirstOpen = false;
    }
  }

  private createOptions(escalas: IEscalaRentabilidade[]): void {
    this.escalaIdByRecordId = {};
    this.options = escalas.map((escala: IEscalaRentabilidade) => {
      this.escalaIdByRecordId[escala.id] = escala.escalaId;
      return {
        id: escala.id,
        label: escala.nome,
        isSelected: false
      };
    });
  }

  onSelectedValueChanged(option: ISelectOption | null): void {
    const selectedId = option?.id ?? null;
    this.changes.emit(selectedId);
    this.emitChange(selectedId);
    this.markAsTouched();
  }

  protected updateValue(value: number | null): void {
    this.selectedId = value;
    this.applyValue();
  }

  private applyValue(): void {
    if (this.options.length === 0) {
return;
}

    this.options.forEach((option) => {
      option.isSelected = option.id === this.selectedId;
    });
  }

  protected onDisabledStateChange(isDisabled: boolean): void {
    this.settings = {
      ...this.settings,
      isDisabled
    };
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private definirCarregando(carregando: boolean): void {
    this.settings = { ...this.settings, isLoading: carregando };
  }

}
